import React, { useContext, useEffect, useState, useRef } from "react";
import Box from "@mui/system/Box";
import Grid from "@mui/material/Grid";
import Container from "@mui/system/Container";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import { useHistory } from "react-router-dom";
// import { ApiCall } from "./../utility/ApiCalls";
import BackdropLoading from "../components/Common/BackdropLoading";
import UserContext from "../components/Common/UserContext";
import "./styles/Login.css";
import menus from "../user-config.json";
import Api_Call from "../ApiCall";
import { ApiCall } from "../utility/ApiCalls";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

function Login() {
  //States==============================================================================================

  const [loading, setLoading] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorLogin, setErrorLogin] = useState("");
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const {
    userRole,
    setUserName: setDiaplayUserName,
    setUserRole,
    userId,
    setUserId,
    setAccessToken,
    setPassChangeRequired,
    setIsPresenter,
    isPresenter,
  } = useContext(UserContext);

  const currentPathnameRef = useRef(history.location.pathname);
  const currentSearchRef = useRef(history.location.search);

  //Api Call ==============================================================================================
  const signInHandler = async () => {
    if (userName == "" || password == "") return;

    try {
      setLoading(true);

      const api = new Api_Call();
      const data = await api.postData("/USER/LOGIN", {
        user_name: userName,
        password: password,
      });
      if (data.statusCode !== 200) {
        throw new Error(data.body);
      }

      //Set User Identifiers ==============================================================================================

      setAccessToken(data.body["access_token"]);
      setUserId(data.body["user_id"]);
      setPassChangeRequired(data.body["password_change_required"]);
      // Nurse,supervisor=1; auditor,intake,admin=0
      setDiaplayUserName(data.body["name"]);
      sessionStorage.setItem("Name", data.body["name"]);
      sessionStorage.setItem("userName", userName);
      sessionStorage.setItem("userRoleId", data.body["role_id"]);
      sessionStorage.setItem("accessDenied", false);
      setUserRole(data.body["user_role"]);

      sessionStorage.setItem("userRole", data.body["user_role"]);

      if (data.body["user_role"] == "Presenter") {
        setIsPresenter(true);
        sessionStorage.setItem("isPresenter", true);
      }
      sessionStorage.setItem("UserID", data.body["user_id"]);

      sessionStorage.setItem(
        "Clinical",
        menus[data.body["user_role"].toLowerCase()]["clinical"]
      );

      sessionStorage.setItem(
        "RedirectPage",
        menus[data.body["user_role"].toLowerCase()]["menus"].find(
          (item) => item.landingPage === true
        )["route"]
      );

      if (data.body["password_change_required"]) {
        history.push("/ChangePassword");
        return;
      }

      //Redirection(role based)==============================================================================================
      else {
        // setUserRole(data.body["user_role"]);

        // sessionStorage.setItem("userRole", data.body["user_role"]);
        // sessionStorage.setItem("UserID", data.body["user_id"]);

        // sessionStorage.setItem(
        //   "Clinical",
        //   menus[data.body["user_role"].toLowerCase()]["clinical"]
        // );

        history.push(
          menus[data.body["user_role"].toLowerCase()]["menus"].find(
            (item) => item.landingPage === true
          )["route"]
        );
      }
    } catch (error) {
      setErrorLogin(error.message);
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  //Form Submission==============================================================================================
  const _handleSubmit = async (e) => {
    e.preventDefault();
  };

  useEffect(() => {
    setErrorLogin("");
  }, [userName, password]);

  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
    setUserRole("");
  }, []);

  //UI Component=======================================================================================
  return (
    <>
      {loading ? <BackdropLoading open={loading} /> : ""}
      <Box
        className="login-main"
        style={{
          background: 'url("img/login-bg.png")',
          backgroundSize: "cover",
          boxShadow: "inset 0 0 0 2000px #fb4e0bc4 ",
        }}
      >
        <Container minWidth="xl">
          <Box className="login-container">
            <img src="img/login-bg-box.png" className="login-bg-box" />
            <Paper elevation={10} className="paper-circle">
              <Grid align="center">
                <h2
                  style={{
                    color: "#FB4E0B",
                    fontWeight: 300,
                    fontSize: 35,
                    margin: 10,
                  }}
                >
                  Sign In
                </h2>
                <form onSubmit={_handleSubmit}>
                  <input
                    type="text"
                    required
                    placeholder="Username"
                    style={{ borderRadius: 25 }}
                    className="login-input-group-input"
                    value={userName}
                    onChange={(e) => {
                      setUserName(e.target.value);
                    }}
                  />
                  <input
                    type="password"
                    required
                    placeholder="Enter Password"
                    style={{ borderRadius: 25 }}
                    className="login-input-group-input"
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />

                  <Typography>
                    <Link href="#">Forgot password ?</Link>
                  </Typography>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={disableBtn}
                    style={{
                      borderRadius: 25,
                      color: "#fff",
                      marginTop: "10px",
                    }}
                    onClick={signInHandler}
                  >
                    Sign In
                  </Button>
                  {errorLogin && (
                    <div
                      style={{ marginTop: "5px", color: "red", width: "80%" }}
                    >
                      {errorLogin}
                    </div>
                  )}
                </form>
              </Grid>
            </Paper>
          </Box>
        </Container>
      </Box>
    </>
  );
}
export default Login;
